export default __webpack_public_path__ + "static/media/flip_vertical.a27c6f25.svg";